// UserDocTableV3.js
import React, { useCallback, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Spinner, Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";
import Icon from "@mdi/react";
import { mdiArrowDownCircle, mdiEyeOutline, mdiFolderOutline, mdiPencilOutline, mdiChevronRight } from "@mdi/js";
import AnnexesView from "./AnnexesView";
import UserDocTableV3Search from "./UserDocTableV3Search";
import ModifierButtonModal from "../test/ModifierButtonModal.tsx";
import axios from "axios"; // Assurez-vous d'importer axios
import { setFilterToolsState, clearFilterToolsState } from '../../../store/actions/filterActions'; // Importez les actions

const UserDocTableV3 = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [pageCount] = useState(8); // Nombre d'éléments par page
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date().getFullYear());

  const buildListDates = () => {
    let current = Number(moment().year());
    let dates = [];
    for (let i = current; i >= current - 5; i--) {
      dates.push(i);
    }
    return dates;
  };

  const listDates = buildListDates();
  const urgence = 8;

  useEffect(() => {
    setLoading(true);
    getUserFormeRef();
    props.setCheckForm(true);
  }, []);

  // Supprimez ces useEffect si le filtrage est entièrement géré par Redux
  /*
  useEffect(() => {
    // Le filtrage est désormais géré par Redux, donc cette useEffect est obsolète
  }, [data]);

  useEffect(() => {
    // Le filtrage est désormais géré par Redux, donc cette useEffect est obsolète
  }, [props.filterForms]);
  */

  useEffect(() => {
    if (props.currentPage === "dashboard") {
      getUserFormeRef();
    }
    props.setCallRefreshUserData(true);
  }, [props.currentPage]);

  /*
  useEffect(() => {
    // Empty useEffect, peut être supprimée si inutile
  }, [currentIndex, pageCount]);
  */

  useEffect(() => {
    getUserFormeRef();
  }, [currentDate]);

  const handleGoToURL = useCallback((e, f = null) => navigate(e, { replace: true }), [navigate]);

  const getUserFormeRef = async () => {
    setLoading(true);
    try {
      const result = await axios.get("/Api/user/team/forms/" + currentDate);
      if (result.data) {
        setData(result.data);
        props.forms(result.data);
        props.setCheckForm(false);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleOpenPDFForm = (item) => {
    if (item.dem_state === 1) {
      if (item?.form_state?.doc_link) {
        window.open(item?.form_state?.doc_link, "_blank");
      } else if (item?.form_data?.pdf_data) {
        window.open("/storage/forms/entities/" + item.entity_id + "/" + item.form_data.pdf_data, "_blank");
      }
    }
  };

  const handleAnnexeClick = (e) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "Récupération de vos données",
      allowOutsideClick: false,
      showCancelButton: false,
    });
    MySwal.showLoading();

    axios
      .get("/Api/Form_ref/" + e + "/links")
      .then((result) => {
        setLoading(false);
        MySwal.close();
        let linkData = JSON.parse(result.data.urls);
        MySwal.fire({
          padding: "0px",
          width: "750px",
          color: "#626262",
          background: "#fff",
          showCloseButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          html: <AnnexesView links={linkData} />,
        });
      })
      .catch((err) => {
        setLoading(false);
        Swal.close();
        console.log(err);
      });
  };

  const getDesision = (formState) => {
    let params = [
      { id: 0, value: 0, label: "Néant", color: "#C4C4C4", border: "#CCC" },
      { id: 1, value: 1, label: "En attente", color: "#F1F1F1", border: "#CCC" },
      { id: 2, value: 2, label: "Refus", color: "#FF7168", border: "#CCC" },
      { id: 3, value: 3, label: "Sous-réserve", color: "#FFBC6D", border: "#CCC" },
      { id: 4, value: 4, label: "Favorable", color: "#58D2C3", border: "#CCC" },
      { id: 5, value: 5, label: "Tacite", color: "#CE92FC", border: "#CCC" },
    ];

    return (
      <span className={"d-flex justify-content-start items-center font-medium"}>
        <span className={"ue-bullet-state"} style={{ backgroundColor: params[Number(formState)].color }}></span>
        {params[Number(formState)].label}
      </span>
    );
  };

  const onSearch = (val, options) => {
   props.setFilter({
     ...options,
     critter: val,
   });
   setCurrentIndex(0);
 }; 

  // Nouvelle useEffect pour gérer le filtrage global
  useEffect(() => {
    const { filter } = props;
    if (!filter) {
      // Si aucun filtre local, appliquer seulement filterForms
      let filtered = data.filter((e) => {
        switch (props.filterForms) {
          case "emergency":
            return e.emergency_days <= 0 && e.emergency_days >= urgence * -1 && e.dem_state !== 1;
          case "current":
            return e.emergency_days <= 0 && e.dem_state < 1;
          case "abonnement":
            return e.emergency_days <= 0 && e.dem_state < 2;
          default:
            return true; // Toutes les données
        }
      });
      setFilteredData(filtered);
    } else {
      // Appliquer filterForms et le filtre local seulement si critter est présent
      if (filter.critter) {
        let filtered = data.filter((item) => {
          // Appliquer filterForms
          let filterFormsCondition;
          switch (props.filterForms) {
            case "emergency":
              filterFormsCondition = item.emergency_days <= 0 && item.emergency_days >= urgence * -1 && item.dem_state !== 1;
              break;
            case "current":
              filterFormsCondition = item.emergency_days <= 0 && item.dem_state < 1;
              break;
            case "abonnement":
              filterFormsCondition = item.emergency_days <= 0 && item.dem_state < 2;
              break;
            default:
              filterFormsCondition = true; // Toutes les données
          }

          // Appliquer le filtre local seulement si critter est défini
          let localFilterCondition = true;
          if (filter.type === "decision") {
            localFilterCondition = Number(item.dem_state) === Number(filter.critter);
          } else if (filter.type === "text") {
            localFilterCondition = item[filter.col]?.toLowerCase().includes(filter.critter?.toLowerCase());
          } else if (filter.type === "date") {
            let deb = new Date(filter.critter[0]);
            let end = new Date(filter.critter[1]);
            let checkDate = new Date(item[filter.col]);
            localFilterCondition = checkDate > deb && checkDate < end;
          }

          return filterFormsCondition && localFilterCondition;
        });
        setFilteredData(filtered);
      } else {
        // Si filter.critter est null ou vide, n'appliquer que filterForms
        let filtered = data.filter((e) => {
          switch (props.filterForms) {
            case "emergency":
              return e.emergency_days <= 0 && e.emergency_days >= urgence * -1 && e.dem_state !== 1;
            case "current":
              return e.emergency_days <= 0 && e.dem_state < 1;
            case "abonnement":
              return e.emergency_days <= 0 && e.dem_state < 2;
            default:
              return true; // Toutes les données
          }
        });
        setFilteredData(filtered);
      }
    }
    setCurrentIndex(0); // Réinitialiser à la première page après le filtrage
  }, [props.filter, data, props.filterForms]);

  const renderState = (emergency, dem_state) => {
    
    if (emergency > -10 && emergency < 0 && dem_state !== 1 && dem_state !== 2) {
      return <span className={"ue-form-status-urgent"}>Urgent</span>;
    } else if (emergency < 0 && dem_state !== 1) {
      return <span className={"ue-form-status"}>En cours</span>;
    } else if (dem_state === 1) {
      return <span className={"ue-form-status-dispo"}>Disponible</span>;
    }
    return <span className={"ue-form-status-outdated"}>Dépassé </span>;
    
  };

  const renderRow = (item, index) => {
    return (
      <tr key={item.id}>
        <td>
          <span className={"text-center"}>{item.doctype}</span>
        </td>
        <td className={"d-none d-md-table-cell text-center"}>
          <div
            onClick={() =>
              props.setCurrentCenterPage("formDetail", {
                formDataId: item.id,
              })
            }
          >
            {renderState(item.emergency_days, item.dem_state)}
          </div>
        </td>
        <td>
          <span className={"d-inline-block "} style={{ maxWidth: "158px" }}>
            {item.code}
          </span>
        </td>
        <td className={"d-none d-md-table-cell"}>
          <span className={""}>{item.insee_com}</span>
        </td>
        <td className={"d-none d-md-table-cell"} role="button">
          <OverlayTrigger
            key={item.id}
            placement="top"
            overlay={
              <Tooltip id={item.id}>
                {item?.terr_code_all
                  ? String(item?.terr_code_all)
                      .replace(/\s+/g, "")
                      .split(",")
                      .map((terr, idx) => {
                        return idx > 0 ? "," + String(terr).substring(8) : String(terr).substring(8);
                      })
                  : String(item?.terr_code_base).substring(8)}
              </Tooltip>
            }
          >
            <span>
              {item?.terr_code_all
                ? String(item?.terr_code_all)
                    .replace(/\s+/g, "")
                    .split(",")
                    .map((terr, idx) => {
                      return idx === 0 ? String(terr).substring(8) : idx === 1 ? ",..." : null;
                    })
                : String(item?.terr_code_base).substring(8)}
            </span>
          </OverlayTrigger>
        </td>
        <td className={"d-none d-md-table-cell"}>
          <span>{item.terr_addr}</span>
        </td>
        <td className={"d-none d-md-table-cell"}>
          <span>{item.dem_name}</span>
        </td>
        <td className={"d-none d-md-table-cell text-center"}>
          <span>{moment(item.dem_date).format("L")}</span>
        </td>
        <td className={"d-none d-md-table-cell text-center"}>
          <span>
            {item?.form_state?.date_limit
              ? moment(item?.form_state?.date_limit).format("L")
              : moment(item.dem_date).add(30, "days").format("L")}
          </span>
        </td>
        <td className={"d-none d-md-table-cell text-center"}>
          {item.dem_valide ? moment(item.dem_valide).format("L") : "-"}
        </td>
        <td>
          {item?.form_state ? (
            getDesision(item.form_state.state_id)
          ) : (
            <div className={"d-flex justify-content-start items-center"}>
              <span
                className={"ue-bullet-state"}
                style={{
                  backgroundColor: "unset",
                  border: "1.5px solid #CCC",
                }}
              ></span>
              ND
            </div>
          )}
        </td>
        <td
          className={"text-center ue-dashboard-btn"}
          onClick={() =>
            props.setCurrentCenterPage("formDetail", {
              formDataId: item.id,
            })
          }
        >
          {item?.dem_state === 1 && item?.form_data?.pdf_data ? (
            <span>
              <Icon path={mdiEyeOutline} size={0.9} color={"#333333"} />
            </span>
          ) : (
            <span>
              <Icon path={mdiPencilOutline} size={0.9} color={"#333333"} />
            </span>
          )}
        </td>
        {/* <td className={"text-center ue-dashboard-btn"}>
          <ModifierButtonModal item={item} />
        </td> */}
        <td
          className={"d-none d-md-table-cell text-center ue-dashboard-btn"}
          onClick={() => handleAnnexeClick(item.id)}
        >
          <span>
            <Icon path={mdiFolderOutline} size={0.9} color={"#333333"} />
          </span>
        </td>
        <td
          className={"d-none d-md-table-cell  text-center ue-dashboard-btn"}
          onClick={() => {
            handleOpenPDFForm(item);
          }}
        >
          <span>
            {item?.dem_state === 1 && item?.form_data?.pdf_data ? (
              <Icon path={mdiArrowDownCircle} size={0.9} color={"var(--theme-primary)"} />
            ) : (
              <Icon path={mdiArrowDownCircle} size={0.9} color={"#d2d2d2"} />
            )}
          </span>
        </td>
      </tr>
    );
  };

  const setPaginationUrl = () => {
    let content = [];
    for (let i = 0; i < filteredData.length; i += pageCount) {
      const pageNumber = Math.floor(i / pageCount) + 1;
      content.push(
        <li key={i} className="page-item">
          <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setCurrentIndex(i); }}>
            {pageNumber}
          </a>
        </li>
      );
    }
    return content;
  };

  const selectRef = useRef();
  const [selectedValue, setSelectedValue] = useState("");

  const handleButtonClick = () => {
    selectRef.current.size = selectRef.current.size > 1 ? 0 : 2; // Toggle dropdown
  };

  return (
    <div className="card rounded-0  mt-md-4  text-black w-100 h-100 border-0">
      <div className="card-body text-dark">
        <div className={"d-flex flex-column flex-md-row w-100 justify-content-between align-items-center my-4"}>
          <div
            className={"card-title d-flex flex-grow-1 justify-content-start align-items-center my-2 my-md-0 ml-2"}
            style={{ minWidth: "160px" }}
          >
            <div style={{ position: "relative" }}>
              <Icon
                className={"my-auto"}
                path={mdiChevronRight}
                onClick={handleButtonClick}
                size={1.0}
                style={{
                  color: "#7B858B",
                  backgroundColor: "#F9F9F9",
                  top: "213px",
                  left: "135px",
                  borderRadius: "4px",
                }}
              />

              <select
                ref={selectRef}
                value={currentDate}
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  opacity: 0,
                  width: "100%",
                  height: "100%",
                }}
                onChange={(e) => {
                  setCurrentDate(e.target.value);
                  setSelectedValue(e.target.value);
                }}
              >
                {listDates ? (
                  listDates.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))
                ) : (
                  <option value={currentDate}>{currentDate}</option>
                )}
              </select>
            </div>
            <div className={"h5 ml-2 font-weight-bold mb-0"}>Dossiers récents {currentDate}</div>
          </div>
          <UserDocTableV3Search onSearch={onSearch} />
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12 mb-2 text-center">
              <Spinner animation="border" variant="primary" size={"sm"} />
              <p>Chargement des données...</p>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column overflow-hidden">
            <table className="table ue-dashboard-table-v3">
              <thead>
                <tr>
                  <th scope="col text-center">Type</th>
                  <th scope="col" className={"d-none d-md-table-cell text-center"}>
                    Statut
                  </th>
                  <th scope="col">Numéro</th>
                  <th scope="col" className={"d-none d-md-table-cell"}>
                    Commune
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell"}>
                    Parcelle
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell"}>
                    Adresse du bien
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell"}>
                    Demandeur
                  </th>
                  <th scope="col">Dossier</th>
                  <th scope="col" className={"d-none d-md-table-cell text-center"}>
                    Date demande
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell text-center"}>
                    Date livraison
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell text-center"}>
                    Décision
                  </th>

                  <th scope="col" className={"text-center"}>
                    Modifier
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell text-center"}>
                    Annexe
                  </th>
                  <th scope="col" className={"d-none d-md-table-cell  text-center"}>
                    Document
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length ? (
                  filteredData
                    .slice(currentIndex, currentIndex + pageCount) // Appliquer la pagination ici
                    .map((item, index) => renderRow(item, index))
                ) : (
                  <tr>
                    <td colSpan={15} className={"text-center"}>
                      <span>Pas de document disponible pour l'année en cours.</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-center">
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    aria-label="Previous"
                    onClick={(e) => { e.preventDefault(); setCurrentIndex(0); }}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                {filteredData.length ? setPaginationUrl() : null}
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    aria-label="Next"
                    onClick={(e) => { e.preventDefault(); setCurrentIndex(Math.max(filteredData.length - pageCount, 0)); }}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  showCenter: state.LeftPanelReducer.showCenter,
  showCenterSection: state.LeftPanelReducer.showCenterSection,
  idUser: state.MeReducer.id,
  currentPage: state.DashboardReducer.current_page,
  entity: state.MeReducer.entity,
  role: state.MeReducer.role,
  filterForms: state.DashboardReducer.filterForm,
  filter: state.filter.filter, // Accéder au filtre depuis Redux
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (filter) => dispatch(setFilterToolsState(filter)),
  clearFilter: () => dispatch(clearFilterToolsState()),
  setIgnKey: (e) => dispatch({ type: "SET_IGN_API_KEY", data: e }),
  setCurrentEntity: (e) =>
    dispatch({
      type: "SET_CURRENT_ENTITY",
      data: { currentEntity: e },
    }),
  showCenterSection: (e) => dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
  setCurrentCenterPage: (e, arg = null) => dispatch({ type: "SET_CURRENT_PAGE", data: e, arg: arg }),
  setDashboardFilterForm: (e) => dispatch({ type: "SET_DASHBORD_FILTER_FORM", data: e }),
  setCheckForm: (e) => dispatch({ type: "SET_CHECK_FORMS", data: e }),
  setCallRefreshUserData: (e) => dispatch({ type: "SET_CALL_REFRESH_USER_DATA", data: e }),
  forms: (data) => dispatch({ type: "SET_FORMS", data }), // Assurez-vous d'avoir cette action
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDocTableV3);
